export default [
  {
    path: '/callback',
    name: 'callback',
    meta: {
      showSidebar: false,
    },
    component: () => import('@/modules/auth/Callback.vue'),
  },
];
